export default __webpack_public_path__ + "static/media/discover.7d5f5005.png";